import { makeAutoObservable } from "mobx"

class CommonStore {
  recommendedModal = false

  GlossaryId = 0
  GlossaryAutoPlay = true
  keyTermsId = 0
  keyTermName = ""
  keyTermsAutoPlay = true
  WhatIsId = 0
  WhatIsAutoPlay = true
  WhatIsModal = false
  HPPModal = false
  StoryModal = false
  documentsModal = false
  expertModal = false
  keyTermsModal = false
  planWorksTab = '0'
  planWorks_Story1 = 0
  planWorks_Story2 = 0
  // fundPerformanceModal = false
  constructor() {
    makeAutoObservable(this)
  }

  setRecommendedModal = (data) => (this.recommendedModal = data)

  setGlossaryId = (data) => (this.GlossaryId = data)
  setGlossaryPlay = (data) => (this.GlossaryAutoPlay = data)
  setkeyTermsId = (data) => (this.keyTermsId = data)
  setkeyTermsAutoPlay = (data) => (this.keyTermsAutoPlay = data)
  setkeyTermName = (data) => (this.keyTermName = data)
  setWhatIsId = (data) => (this.WhatIsId = data)
  setWhatIsModal = (data) => (this.WhatIsModal = data)
  whatIsTermsAutoPlay = (data) => (this.WhatIsAutoPlay = data)

  setHPPModal = (data) => (this.HPPModal = data)

  setStoryModal = (data) => (this.StoryModal = data)

  setdocumentsModal = (data) => (this.documentsModal = data)
  setexpertModal = (data) => (this.expertModal = data)
  setKeyTermsModal = (data) => (this.keyTermsModal = data)
  setplanWorksTab = (data) => (this.planWorksTab = data)
  setplanStory1 = (data) => (this.planWorks_Story1 = data)
  setplanStory2 = (data) => (this.planWorks_Story2 = data)

  // setfundPerformanceModal = (data) => (this.fundPerformanceModal = data)
}

export default new CommonStore()
